/* eslint-disable no-console */

import { register } from "register-service-worker";
import vue from "./main";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}sw.js`, {
    ready(registerEvent) {
      setInterval(() => {
        registerEvent.update();
      }, 3000);

      // console.log(
      //   'App is being served from cache by a service worker.\n' +
      //   'For more details, visit https://goo.gl/AFskqB'
      // )
    },
    cached() {
      //console.log('Content has been cached for offline use.')
    },
    updated() {
      //console.log("New content is available; please refresh.");
      vue.$store.commit("SET_AVAILABLE_UPDATE_STATUS", true);
      let updatedEvent = new Event("availableUpdate");
      window.dispatchEvent(updatedEvent);
      //console.log("New content is available; please refresh.");
    },
    offline() {
      //console.log("No internet connection found. App is running in offline mode.");
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
